<template>

    <div>

        <el-dialog title="配置详情" width="60%" :visible="confDialogVisible" @close="close" center>
            <el-form :model="form_conf_record" ref="form_conf_record" label-width="85px" class="demo-ruleForm"
                     :rules="rule_record" status-icon>
                <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                        <el-form-item label="序号" prop="seq">
                            <el-input v-model="form_conf_record.seq" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="confRecordInfo.level == 3">
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                        <el-form-item label="条款编号" prop="manualSeq">
                            <el-input v-model="form_conf_record.manualSeq"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                        <el-form-item label="描述" prop="category">
                            <el-input type="textarea" rows="5" v-model="form_conf_record.category" maxlength="500"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="confRecordInfo.level == 3">
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                        <el-form-item label="评分标准" prop="standardsOfGrading">
                            <el-input type="textarea" rows="5" v-model="form_conf_record.standardsOfGrading" maxlength="500"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                        <el-form-item label="权重" prop="weight">
                            <el-input v-model="form_conf_record.weight" size="small" :disabled="form_conf_record.level > 2"
                                      @input.native="handleWeightInput"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                        <el-form-item label="应得分值" prop="deservescore">
                            <el-input v-model="form_conf_record.deservescore" size="small" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row style="text-align: center">
                    <el-button center="true" type="primary" @click="save">确 定</el-button>
                    <el-button center @click="close">关 闭</el-button>
                </el-row>
            </el-form>
        </el-dialog>

    </div>

</template>


<script>

    import AssessmentServer from "../../../api/assessment";
    import {formatDate} from "element-ui/lib/utils/date-util";

    let that = this;

    export default {

        name: "confRecordDialog",

        props: ['confDialogVisible', 'confRecordInfo'],

        components: {},

        data() {

            return {

                form_conf_record: {
                    id: 0,
                    category: '',
                    standardsOfGrading: '', //评分标准
                    parent: '',
                    seq: '',
                    manualSeq: '',          //条款
                    weight: 0,
                    deservescore: 100,
                    order: 0,
                    version: '',
                    changeby: localStorage.getItem("username"),
                    changedate: formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                    level: '',
                },

                rule_record: {
                    category: [
                        {
                            required: true,
                            trigger: 'blur',
                            message: '请输入考核项',
                        }
                    ],

                },

            }
        },

        methods: {

            queryConfRecordDetail(id) {
                let that = this;
                AssessmentServer.assessmentConf.get(id).then((responseBody) => {
                    if ((responseBody.data != null) && (responseBody.data.data != null)) {
                        this.form_conf_record = responseBody.data.data;
                    }
                }).catch(error => {
                    this.$message.error(error);
                });
            },

            save() {
                //前两个层级权重必输
                if (that.form_conf_record.level < 3 && (that.form_conf_record.weight == null || that.form_conf_record.weight == '')) {
                    that.$message.error('请录入权重！');
                    return;
                }
                that.$refs['form_conf_record'].validate((valid) => {
                    if (!valid) {
                        return;
                    } else {
                        that.form_conf_record.changeby = localStorage.getItem('realname');
                        if (that.confRecordInfo.id == null) {
                            AssessmentServer.assessmentConf.add(that.form_conf_record).then(responseBody => {
                                if (responseBody.data.code != 200) {
                                    that.$message.error(responseBody.data.message);
                                } else {
                                    that.form_conf_record.changedate = formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss');
                                    that.$message.success('评估项添加成功');
                                    that.confDialogVisible = false;
                                    that.$emit("afterSavedConfRecord", this.form_conf_record);
                                }
                            });
                        } else {
                            AssessmentServer.assessmentConf.update(that.form_conf_record.id, that.form_conf_record).then(responseBody => {
                                if (responseBody.data.code != 200) {
                                    that.$message.error(responseBody.data.message);
                                } else {
                                    that.form_conf_record.changedate = formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss');
                                    that.$message.success('评估项更新成功');
                                    that.confDialogVisible = false;
                                    that.$emit("afterSavedConfRecord", this.form_conf_record);
                                }
                            });
                        }

                    }
                });
            },

            close() {
                this.queryConfRecordDetail(that.form_conf_record.id);
                this.$emit('update:confDialogVisible', false);
            },

            handleWeightInput(e) {
                let target = (e.target.value.match(/^-?\d*(\.?\d{0,2})/g));
                this.form_conf_record.weight = target[0];
            },

        },

        watch: {
            confRecordInfo: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    if (newVal.id != null && newVal.id != 0) {
                        if (this.$refs['form_conf_record'] != null) {
                            this.$refs['form_conf_record'].clearValidate();
                        }
                        this.queryConfRecordDetail(newVal.id);
                    } else {
                        this.form_conf_record = newVal;
                    }
                    if (newVal.level > 2) {
                        this.form_conf_record.deservescore = '';
                    }
                }
            },
        },

        mounted() {
            that = this;
        }
    }

</script>